class LpTabs extends HTMLElement {
    connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[data-lp-tab]'));

        if (!this.buttons.length) {
            return;
        }

        this.hoistButtons();


        const marked = this.buttons.findIndex(
            (button) => button.getAttribute('aria-expanded') === 'true',
        );

        const open = marked === -1 ? 0 : marked;

        this.apply(open);
        this.reveal(this.buttons[open]);

        if (this.buttons.length < 2) {
            return;
        }

        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
    }


    hoistButtons() {
        const strip = this.querySelector('[data-lp-tabs-strip]');

        if (!strip) {
            return;
        }

        strip.append(...this.buttons);
    }

    /**
     * @param {Element} button
     */
    reveal(button) {
        const strip = button?.parentElement;

        if (!strip?.matches('[data-lp-tabs-strip]')) {
            return;
        }

        const stripBox = strip.getBoundingClientRect();
        const buttonBox = button.getBoundingClientRect();
        const start = strip.scrollLeft + buttonBox.left - stripBox.left;
        const end = start + buttonBox.width;

        if (start < strip.scrollLeft) {
            strip.scrollLeft = start;
        } else if (end > strip.scrollLeft + strip.clientWidth) {
            strip.scrollLeft = end - strip.clientWidth;
        }
    }

    /** @param {Element} button */
    panelFor(button) {
        return document.getElementById(button.getAttribute('aria-controls'));
    }

    onClick = (event) => {
        const button = event.target.closest('[data-lp-tab]');

        if (!button || !this.buttons.includes(button)) {
            return;
        }

        this.select(this.buttons.indexOf(button));
    };

    onKeydown = (event) => {
        const current = this.buttons.indexOf(event.target.closest('[data-lp-tab]'));

        if (current === -1) {
            return;
        }

        const last = this.buttons.length - 1;
        let next = null;

        switch (event.key) {
            case 'ArrowRight':
            case 'ArrowDown':
                next = current === last ? 0 : current + 1;
                break;
            case 'ArrowLeft':
            case 'ArrowUp':
                next = current === 0 ? last : current - 1;
                break;
            case 'Home':
                next = 0;
                break;
            case 'End':
                next = last;
                break;
            default:
                return;
        }

        event.preventDefault();
        this.select(next, { focus: true });
    };

    /**
     * Open one panel and close the rest, without moving focus or scroll.
     * @param {number} index
     */
    apply(index) {
        this.buttons.forEach((button, position) => {
            const isOpen = position === index;
            const panel = this.panelFor(button);

            button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

            if (panel) {
                panel.hidden = !isOpen;
            }
        });
    }

    /**
     * @param {number} index
     * @param {{focus?: boolean}} [options]
     */
    select(index, options = {}) {
        const selected = this.buttons[index];

        if (!selected) {
            return;
        }

        this.apply(index);

        this.reveal(selected);

        if (options.focus) {
            selected.focus();
        }

        this.dispatchEvent(new CustomEvent('lp-tabs:change', {
            bubbles: true,
            detail: { index, button: selected },
        }));
    }
}

if (!customElements.get('lp-tabs')) {
    customElements.define('lp-tabs', LpTabs);
}
